export const getLocalizationDefault = `query GetLocalizationDefault($filter: DefaultRequest!) {
  localizationDefault(filter: $filter) {
    localizationDefault {
      pkId
      version
      region
      country
      countryDesc
      productFamily
      productDesc
      productGroup
      feature
      featureValue
      locFeature
      locFeatureValue
      status
      comments
      whoChanged
      lastModifiedDate
      createDate
    }
    count
  }
}`;

export const getLocalizationAvailability = `query LocalizationAvailability($filter: LocalizationRequest!) {
  localizationAvailability(filter: $filter) {
    localizations {
      pkId
      version
      region
      businessGroup
      productGroup
      productFamily
      productDesc
      feature
      featureValue
      featureDesc
      country
      countryDesc
      category
      startDate
      endDate
      comments
      status
      apRegion
      euRegion
      naRegion
      laRegion
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
    }
  }
}`;
export const getRegionsLOCAvailability = `query RegionallocalizationAvailability($filter: LocalizationRequest!) {
  RegionallocalizationAvailability(filter: $filter) {
    localizations {
      pkId
      version
      region
      businessGroup
      productGroup
      productFamily
      feature
      featureValue
      featureDesc
      country
      countryDesc
      category
      wwStartDate
      wwEndDate
      regStartDate
      regEndDate
      apRegion
      euRegion
      naRegion
      laRegion
      comments
      status
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
    }
  }
}
 
 `;
